import React, {useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
    HashRouter as Router,
    useLocation,
    withRouter,
} from "react-router-dom";
import AppRoutes from "./routes";
import Headermain from "../header";
import CustomCursor from "../components/customcursor";
import "./App.css";

function _ScrollToTop(props) {
    const {pathname} = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return props.children;
}

const ScrollToTop = withRouter(_ScrollToTop);

export default function App() {
    return (
        <Router>
            <CustomCursor/>
            <ScrollToTop>
                <Headermain/>
                <AppRoutes/>
            </ScrollToTop>
        </Router>
    );
}
